const mediaItems = [
  {
    title: '《今日娱乐圈大揭秘》独家深度还原事件全貌',
    source: '51爆料编辑部',
    views: '128.6万',
    duration: '15:42',
    image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20editorial%20style%20thumbnail%20with%20warm%20crimson%20and%20dark%20tones%2C%20abstract%20news%20studio%20background%20with%20soft%20spotlight%20effect%2C%20cinematic%20lighting%2C%20professional%20video%20production%20feel%2C%20no%20text%20or%20lettering%2C%20atmospheric%20depth&width=800&height=450&seq=media-01-bl&orientation=landscape',
  },
  {
    title: '51每日大赛本周热点盘点：十大话题一次看完',
    source: '热点追踪组',
    views: '96.3万',
    duration: '22:10',
    image: 'https://readdy.ai/api/search-image?query=A%20warm%20toned%20abstract%20data%20and%20ranking%20visualization%20thumbnail%2C%20amber%20and%20deep%20red%20gradients%2C%20geometric%20patterns%2C%20modern%20infographic%20style%2C%20professional%20editorial%20feel%2C%20soft%20atmospheric%20light%2C%20no%20text&width=800&height=450&seq=media-02-bl&orientation=landscape',
  },
  {
    title: '科技圈年度最大爆料始末：从传闻到确认全记录',
    source: '科技前沿频道',
    views: '87.1万',
    duration: '18:33',
    image: 'https://readdy.ai/api/search-image?query=A%20futuristic%20technology%20themed%20abstract%20thumbnail%20with%20warm%20orange%20and%20crimson%20accents%2C%20digital%20circuit%20patterns%2C%20geometric%20abstract%20shapes%2C%20cinematic%20depth%2C%20professional%20editorial%20style%2C%20no%20text%20or%20lettering&width=800&height=450&seq=media-03-bl&orientation=landscape',
  },
  {
    title: '体育界转会季爆料汇总：豪门动态一网打尽',
    source: '体育解密',
    views: '73.5万',
    duration: '20:05',
    image: 'https://readdy.ai/api/search-image?query=A%20dynamic%20sports%20themed%20abstract%20thumbnail%20with%20warm%20amber%20and%20dark%20red%20tones%2C%20motion%20blur%20effects%2C%20geometric%20shapes%2C%20professional%20editorial%20feel%2C%20atmospheric%20stadium%20light%20vibe%2C%20no%20text%20or%20lettering&width=800&height=450&seq=media-04-bl&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="w-full py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950">
            精选视频
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            每日大赛精选视频，热门爆料视觉化呈现
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {mediaItems.map((item, i) => (
            <div
              key={i}
              className="group rounded-xl overflow-hidden bg-background-100 border border-background-200/60 cursor-pointer transition-all hover:border-primary-200"
            >
              <div className="relative w-full aspect-video overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-950/60 via-transparent to-transparent"></div>
                <div className="absolute bottom-3 right-3 px-2 py-1 rounded-md bg-background-950/70 text-xs text-background-100 font-medium whitespace-nowrap">
                  {item.duration}
                </div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-primary-500/90 flex items-center justify-center transition-transform group-hover:scale-110">
                    <i className="ri-play-fill text-2xl text-background-50 ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 line-clamp-2 leading-snug mb-2">
                  {item.title}
                </h3>
                <div className="flex items-center justify-between text-xs text-foreground-500">
                  <span className="whitespace-nowrap">{item.source}</span>
                  <span className="whitespace-nowrap">{item.views} 次播放</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}